import styled from 'styled-components';
import { underIPhone5 } from '@westwing/ui-kit/breakPoints';

export default styled.p<{ hasError: boolean }>`
    text-align: left;
    font-size: 0.8em;
    color: ${({ theme, hasError }) => (hasError ? theme.colors.red90 : theme.colors.charcoal40)};

    a {
        color: ${({ theme }) => theme.colors.turquoise100};
    }

    ${underIPhone5`
        margin-top: 5px;
        margin-bottom: 5px;
    `}
`;
